import { TranslocoService } from '@jsverse/transloco';
import { Component, OnInit, ViewChild } from '@angular/core';
import {ReportApiService} from 'src/app/data-transfer/services/report-api-service';
import {AuthService} from 'src/app/services/auth-service';
import { TemplateApiService } from 'src/app/data-transfer/services/template-api-service';
import { firstValueFrom, switchMap } from 'rxjs';
import { downloadDocument } from 'src/app/services/document-download';
import { MatMenu } from '@angular/material/menu';
@Component({
  selector: 'app-downloads-menu',
  templateUrl: './downloads-menu.component.html',
  styleUrls: ['./downloads-menu.component.scss']
})
export class DownloadsMenuComponent implements OnInit {

  @ViewChild(MatMenu, { static: true }) menu!: MatMenu;
  documents!: { label: string, path: string }[];
  isAdmin = false;

  constructor(
    private translateService: TranslocoService,
    private reportservice: ReportApiService,
    private authService: AuthService,
    private templateService: TemplateApiService
  ) {
    this.isAdmin = this.authService.isUserAdmin();
  }

  ngOnInit() {
    this.setDocuments();
  }

  private setDocuments() {
    const documentsFolder = 'https://cockpit.packaging-cockpit.com/downloads/documents/';
    const format = '.pdf';
    const isGerman = localStorage.getItem('language') === 'de';

    this.documents = [
      {
        path: isGerman ? `${documentsFolder}UserManual_DE${format}` :
          `${documentsFolder}UserManual${format}`,
        label: this.translateService.translate('downloads.file.manual')
      },
      {
        path: isGerman ? `${documentsFolder}FH-Campus-Wien_Circular-Packaging-Design-Guideline_V04_DE${format}` :
          `${documentsFolder}FH-Campus-Wien_Circular-Packaging-Design-Guideline_V04_EN${format}`,
        label: this.translateService.translate('downloads.file.guidelines')
      },
      {
        path: isGerman ? `${documentsFolder}Bewertung_RF${format}` :
          `${documentsFolder}Recyclability-Assessment-CA${format}`,
        label: this.translateService.translate('downloads.file.methods')
      }
    ];
  }

  clickExternalHtml() {
    const link = document.createElement('a');
    link.href = 'api-documentation/index.html';
    link.target = '_blank';
    link.click();
  }


  async downloadUsageReport() {
    const observable = this.reportservice.generateUsageReport();
    const reportPdf = await firstValueFrom(observable);
    const pdfUrl = window.URL.createObjectURL(reportPdf);
    window.open(pdfUrl, '_blank');
  }

  async downloadPUImportTemplate() {
    const subscription = this.templateService.getPUImporterTemplate()
      .subscribe(fileToSave => { downloadDocument(fileToSave); subscription.unsubscribe()});
  }
}
